export const sources = {
  PROJECT_SETTINGS_PAGE: 'uf.settings.project',
};
